<template>
    <div class="form" v-if="status === 'loaded'">
        <div class="row">
            <div class="col-12">
                <h4>Datos del expediente</h4>
            </div>
        </div>

        <div class="grid-template">
            <template v-if="can('expedient.form.fill.general-data')">
                <template v-if="expedient.contract_type === 'mortgage'">
                    <div class="form-group">
                        <label class="form-label"
                               for="tipo_demanda">
                            Tipo de demanda
                        </label>
                        <select class="form-select"
                                name="tipo_demanda"
                                id="tipo_demanda"
                                :maxlength="max_input_length"
                                :value="form_json['tipo_demanda']"
                                @change="fireFormUpdated">
                            <option value="Suelo">Suelo</option>
                            <option value="IRPH">IRPH</option>
                            <option value="Gastos hipotecarios">Gastos hipotecarios</option>
                            <option value="Posiciones deudoras">Posiciones deudoras</option>
                            <option value="Comisión Apertura">Comisión Apertura</option>
                            <option value="Otros">Otros</option>
                        </select>
                    </div>

                    <div class="form-group">
                        <label class="form-label"
                               for="entidad_contratacion_original">
                            Entidad contratación original
                        </label>
                        <input class="form-control"
                               type="text"
                               name="entidad_contratacion_original"
                               id="entidad_contratacion_original"
                               :maxlength="max_input_length"
                               :value="form_json['entidad_contratacion_original']"
                               @input="fireFormUpdated"
                               @change="fireFormUpdated">
                    </div>

                    <div class="form-group">
                        <label class="form-label"
                               for="notario">
                            Notario (nombre completo)
                        </label>
                        <input class="form-control"
                               type="text"
                               name="notario"
                               id="notario"
                               :maxlength="max_input_length"
                               :value="form_json['notario']"
                               @input="fireFormUpdated"
                               @change="fireFormUpdated">
                    </div>

                    <div class="form-group">
                        <label class="form-label"
                               for="numero_protocolo">
                            Nº protocolo
                        </label>
                        <input class="form-control"
                               type="text"
                               name="numero_protocolo"
                               id="numero_protocolo"
                               :maxlength="max_input_length"
                               :value="form_json['numero_protocolo']"
                               @input="fireFormUpdated"
                               @change="fireFormUpdated">
                    </div>

                    <div class="form-group">
                        <label class="form-label"
                               for="fecha_firma_escritura">
                            Fecha firma escritura
                        </label>
                        <input class="form-control"
                               type="text"
                               name="fecha_firma_escritura"
                               id="fecha_firma_escritura"
                               :maxlength="max_input_length"
                               :value="form_json['fecha_firma_escritura']"
                               @input="fireFormUpdated"
                               @change="fireFormUpdated">
                    </div>

                    <div class="form-group">
                        <label class="form-label"
                               for="existe_documento_escritura_prestamo_hipotecario">
                            Documento escritura préstamo hipotecario
                        </label>
                        <input class="form-check-input"
                               type="checkbox"
                               name="existe_documento_escritura_prestamo_hipotecario"
                               id="existe_documento_escritura_prestamo_hipotecario"
                               :maxlength="max_input_length"
                               :value="form_json['existe_documento_escritura_prestamo_hipotecario']"
                               :checked="form_json['existe_documento_escritura_prestamo_hipotecario'] === 'true' ? true : null"
                               @change="fireFormUpdated">
                    </div>

                    <div class="form-group">
                        <label class="form-label"
                               for="existe_factura_gestoria">
                            Factura gestoría
                        </label>
                        <input class="form-check-input"
                               type="checkbox"
                               name="existe_factura_gestoria"
                               id="existe_factura_gestoria"
                               :maxlength="max_input_length"
                               :value="form_json['existe_factura_gestoria']"
                               :checked="form_json['existe_factura_gestoria'] === 'true' ? true : null"
                               @change="fireFormUpdated">
                    </div>

                    <div class="form-group">
                        <label class="form-label"
                               for="existe_factura_registro_propiedad">
                            Factura Registro de la Propiedad
                        </label>
                        <input class="form-check-input"
                               type="checkbox"
                               name="existe_factura_registro_propiedad"
                               id="existe_factura_registro_propiedad"
                               :maxlength="max_input_length"
                               :value="form_json['existe_factura_registro_propiedad']"
                               :checked="form_json['existe_factura_registro_propiedad'] === 'true' ? true : null"
                               @change="fireFormUpdated">
                    </div>

                    <div class="form-group">
                        <label class="form-label"
                               for="existe_factura_notaria">
                            Factura Notaría
                        </label>
                        <input class="form-check-input"
                               type="checkbox"
                               name="existe_factura_notaria"
                               id="existe_factura_notaria"
                               :maxlength="max_input_length"
                               :value="form_json['existe_factura_notaria']"
                               :checked="form_json['existe_factura_notaria'] === 'true' ? true : null"
                               @change="fireFormUpdated">
                    </div>

                    <div class="form-group">
                        <label class="form-label"
                               for="existe_factura_tasacion">
                            Factura Tasación
                        </label>
                        <input class="form-check-input"
                               type="checkbox"
                               name="existe_factura_tasacion"
                               id="existe_factura_tasacion"
                               :maxlength="max_input_length"
                               :value="form_json['existe_factura_tasacion']"
                               :checked="form_json['existe_factura_tasacion'] === 'true' ? true : null"
                               @change="fireFormUpdated">
                    </div>

                    <div class="form-group">
                        <label class="form-label"
                               for="existe_comision_apertura">
                            Comisión de apertura
                        </label>
                        <input class="form-check-input"
                               type="checkbox"
                               name="existe_comision_apertura"
                               id="existe_comision_apertura"
                               :maxlength="max_input_length"
                               :value="form_json['existe_comision_apertura']"
                               :checked="form_json['existe_comision_apertura'] === 'true' ? true : null"
                               @change="fireFormUpdated">
                    </div>

                    <div class="form-group">
                        <label class="form-label"
                               for="existe_clausula_suelo">
                            Cláusula suelo
                        </label>
                        <input class="form-check-input"
                               type="checkbox"
                               name="existe_clausula_suelo"
                               id="existe_clausula_suelo"
                               :maxlength="max_input_length"
                               :value="form_json['existe_clausula_suelo']"
                               :checked="form_json['existe_clausula_suelo'] === 'true' ? true : null"
                               @change="fireFormUpdated">
                    </div>

                    <div class="form-group">
                        <label class="form-label"
                               for="existe_irph">
                            IRPH
                        </label>
                        <input class="form-check-input"
                               type="checkbox"
                               name="existe_irph"
                               id="existe_irph"
                               :maxlength="max_input_length"
                               :value="form_json['existe_irph']"
                               :checked="form_json['existe_irph'] === 'true' ? true : null"
                               @change="fireFormUpdated">
                    </div>
                </template>

                <template v-if="expedient.contract_type === 'usury_card'">
                    <div class="form-group">
                        <label class="form-label"
                               for="tipo_demanda">
                            Tipo de demanda
                        </label>
                        <select class="form-select"
                                name="tipo_demanda"
                                id="tipo_demanda"
                                :maxlength="max_input_length"
                                :value="form_json['tipo_demanda']"
                                @change="fireFormUpdated">
                            <option value="Rendición de cuentas">Rendición de cuentas</option>
                            <option value="Usura o Transparencia">Usura o Transparencia</option>
                            <option value="Posiciones deudoras">Posiciones deudoras</option>
                            <option value="Otro">Otro</option>
                        </select>
                    </div>

                    <div class="form-group">
                        <label class="form-label"
                               for="usury_card_entidad_contratacion_original">
                            Entidad contratación original
                        </label>
                        <input class="form-control"
                               type="text"
                               name="entidad_contratacion_original"
                               id="usury_card_entidad_contratacion_original"
                               :maxlength="max_input_length"
                               :value="form_json['entidad_contratacion_original']"
                               @input="fireFormUpdated"
                               @change="fireFormUpdated">
                    </div>

                    <div class="form-group">
                        <label class="form-label"
                               for="usury_card_numero_contrato">
                            Nº contrato
                        </label>
                        <input class="form-control"
                               type="text"
                               name="numero_contrato"
                               id="usury_card_numero_contrato"
                               :maxlength="max_input_length"
                               :value="form_json['numero_contrato']"
                               @input="fireFormUpdated"
                               @change="fireFormUpdated">
                    </div>

                    <div class="form-group">
                        <label class="form-label"
                               for="usury_card_numero_tarjeta">
                            Nº tarjeta
                        </label>
                        <input class="form-control"
                               type="text"
                               name="numero_tarjeta"
                               id="usury_card_numero_tarjeta"
                               :maxlength="max_input_length"
                               :value="form_json['numero_tarjeta']"
                               @input="fireFormUpdated"
                               @change="fireFormUpdated">
                    </div>

                    <div class="form-group">
                        <label class="form-label"
                               for="ano_contratacion">
                            Año contratación
                        </label>
                        <input class="form-control"
                               type="text"
                               name="ano_contratacion"
                               id="ano_contratacion"
                               :maxlength="max_input_length"
                               :value="form_json['ano_contratacion']"
                               @input="fireFormUpdated"
                               @change="fireFormUpdated">
                    </div>

                    <div class="form-group">
                        <label class="form-label"
                               for="existe_contrato">
                            Contrato
                        </label>
                        <input class="form-check-input"
                               type="checkbox"
                               name="existe_contrato"
                               id="existe_contrato"
                               :maxlength="max_input_length"
                               :value="form_json['existe_contrato']"
                               :checked="form_json['existe_contrato'] === 'true' ? true : null"
                               @change="fireFormUpdated">
                    </div>

                    <div class="form-group">
                        <label class="form-label"
                               for="existe_extractos">
                            Extractos
                        </label>
                        <input class="form-check-input"
                               type="checkbox"
                               name="existe_extractos"
                               id="existe_extractos"
                               :maxlength="max_input_length"
                               :value="form_json['existe_extractos']"
                               :checked="form_json['existe_extractos'] === 'true' ? true : null"
                               @change="fireFormUpdated">
                    </div>

                    <div class="form-group">
                        <label class="form-label"
                               for="tae_contrato">
                            TAE en contrato
                        </label>
                        <input class="form-control"
                               type="text"
                               name="tae_contrato"
                               id="tae_contrato"
                               :maxlength="max_input_length"
                               :value="form_json['tae_contrato']"
                               @input="fireFormUpdated"
                               @change="fireFormUpdated">
                    </div>

                    <div class="form-group">
                        <label class="form-label"
                               for="tae_maximo_extractos">
                            TAE máximo en extractos
                        </label>
                        <input class="form-control"
                               type="text"
                               name="tae_maximo_extractos"
                               id="tae_maximo_extractos"
                               :maxlength="max_input_length"
                               :value="form_json['tae_maximo_extractos']"
                               @input="fireFormUpdated"
                               @change="fireFormUpdated">
                    </div>

                    <div class="form-group">
                        <label class="form-label"
                               for="existe_contrato_resuelto">
                            Contrato resuelto
                        </label>
                        <input class="form-check-input"
                               type="checkbox"
                               name="existe_contrato_resuelto"
                               id="existe_contrato_resuelto"
                               :maxlength="max_input_length"
                               :value="form_json['existe_contrato_resuelto']"
                               :checked="form_json['existe_contrato_resuelto'] === 'true' ? true : null"
                               @change="fireFormUpdated">
                    </div>

                    <div class="form-group">
                        <label class="form-label"
                               for="usury_card_lugar_contratacion">
                            Lugar contratación
                        </label>
                        <input class="form-control"
                               type="text"
                               name="lugar_contratacion"
                               id="usury_card_lugar_contratacion"
                               :maxlength="max_input_length"
                               :value="form_json['lugar_contratacion']"
                               @input="fireFormUpdated"
                               @change="fireFormUpdated">
                    </div>

                    <div class="form-group">
                        <label class="form-label"
                               for="usury_card_deuda_reclamada_entidad">
                            Deuda reclamada por entidad
                        </label>
                        <input class="form-control"
                               type="text"
                               name="deuda_reclamada_entidad"
                               id="usury_card_deuda_reclamada_entidad"
                               :maxlength="max_input_length"
                               :value="form_json['deuda_reclamada_entidad']"
                               @input="fireFormUpdated"
                               @change="fireFormUpdated">
                    </div>

                    <div class="form-group">
                        <label class="form-label"
                               for="usury_card_cuadro_ejecucion_recibido">
                            Cuadro ejecución recibido
                        </label>
                        <input class="form-control"
                               type="datetime-local"
                               name="cuadro_ejecucion_recibido"
                               id="usury_card_cuadro_ejecucion_recibido"
                               :maxlength="max_input_length"
                               :value="form_json['cuadro_ejecucion_recibido']"
                               @input="fireFormUpdated"
                               @change="fireFormUpdated">
                    </div>
                </template>

                <template v-if="expedient.contract_type === 'usury_loan'">
                    <div class="form-group">
                        <label class="form-label"
                               for="tipo_demanda">
                            Tipo de demanda
                        </label>
                        <select class="form-select"
                                name="tipo_demanda"
                                id="tipo_demanda"
                                :maxlength="max_input_length"
                                :value="form_json['tipo_demanda']"
                                @change="fireFormUpdated">
                            <option value="Rendición de cuentas">Rendición de cuentas</option>
                            <option value="Usura o Transparencia">Usura o Transparencia</option>
                            <option value="Posiciones deudoras">Posiciones deudoras</option>
                            <option value="Otro">Otro</option>
                        </select>
                    </div>

                    <div class="form-group">
                        <label class="form-label"
                               for="usury_loan_entidad_contratacion_original">
                            Entidad contratación original
                        </label>
                        <input class="form-control"
                               type="text"
                               name="entidad_contratacion_original"
                               id="usury_loan_entidad_contratacion_original"
                               :maxlength="max_input_length"
                               :value="form_json['entidad_contratacion_original']"
                               @input="fireFormUpdated"
                               @change="fireFormUpdated">
                    </div>

                    <div class="form-group">
                        <label class="form-label"
                               for="usury_loan_numero_contrato">
                            Nº contrato
                        </label>
                        <input class="form-control"
                               type="text"
                               name="numero_contrato"
                               id="usury_loan_numero_contrato"
                               :maxlength="max_input_length"
                               :value="form_json['numero_contrato']"
                               @input="fireFormUpdated"
                               @change="fireFormUpdated">
                    </div>

                    <div class="form-group">
                        <label class="form-label"
                               for="usury_loan_numero_prestamo">
                            Nº préstamo
                        </label>
                        <input class="form-control"
                               type="text"
                               name="numero_prestamo"
                               id="usury_loan_numero_prestamo"
                               :maxlength="max_input_length"
                               :value="form_json['numero_prestamo']"
                               @input="fireFormUpdated"
                               @change="fireFormUpdated">
                    </div>

                    <div class="form-group">
                        <label class="form-label"
                               for="usury_loan_ano_contratacion">
                            Año contratación
                        </label>
                        <input class="form-control"
                               type="text"
                               name="ano_contratacion"
                               id="usury_loan_ano_contratacion"
                               :maxlength="max_input_length"
                               :value="form_json['ano_contratacion']"
                               @input="fireFormUpdated"
                               @change="fireFormUpdated">
                    </div>

                    <div class="form-group">
                        <label class="form-label"
                               for="usury_loan_existe_contrato">
                            Contrato
                        </label>
                        <input class="form-check-input"
                               type="checkbox"
                               name="existe_contrato"
                               id="usury_loan_existe_contrato"
                               :maxlength="max_input_length"
                               :value="form_json['existe_contrato']"
                               :checked="form_json['existe_contrato'] === 'true' ? true : null"
                               @change="fireFormUpdated">
                    </div>

                    <div class="form-group">
                        <label class="form-label"
                               for="usury_loan_tae_contrato">
                            TAE en contrato
                        </label>
                        <input class="form-control"
                               type="text"
                               name="tae_contrato"
                               id="usury_loan_tae_contrato"
                               :maxlength="max_input_length"
                               :value="form_json['tae_contrato']"
                               @input="fireFormUpdated"
                               @change="fireFormUpdated">
                    </div>

                    <div class="form-group">
                        <label class="form-label"
                               for="usury_loan_existe_contrato_resuelto">
                            Contrato resuelto
                        </label>
                        <input class="form-check-input"
                               type="checkbox"
                               name="existe_contrato_resuelto"
                               id="usury_loan_existe_contrato_resuelto"
                               :maxlength="max_input_length"
                               :value="form_json['existe_contrato_resuelto']"
                               :checked="form_json['existe_contrato_resuelto'] === 'true' ? true : null"
                               @change="fireFormUpdated">
                    </div>

                    <div class="form-group">
                        <label class="form-label"
                               for="usury_loan_lugar_contratacion">
                            Lugar/forma de contratación
                        </label>
                        <input class="form-control"
                               type="text"
                               name="lugar_contratacion"
                               id="usury_loan_lugar_contratacion"
                               :maxlength="max_input_length"
                               :value="form_json['lugar_contratacion']"
                               @input="fireFormUpdated"
                               @change="fireFormUpdated">
                    </div>

                    <div class="form-group">
                        <label class="form-label"
                               for="usury_loan_deuda_reclamada_entidad">
                            Deuda reclamada por entidad
                        </label>
                        <input class="form-control"
                               type="text"
                               name="deuda_reclamada_entidad"
                               id="usury_loan_deuda_reclamada_entidad"
                               :maxlength="max_input_length"
                               :value="form_json['deuda_reclamada_entidad']"
                               @input="fireFormUpdated"
                               @change="fireFormUpdated">
                    </div>

                    <div class="form-group">
                        <label class="form-label"
                               for="usury_loan_cuadro_ejecucion_recibido">
                            Cuadro ejecución recibido
                        </label>
                        <input class="form-control"
                               type="datetime-local"
                               name="cuadro_ejecucion_recibido"
                               id="usury_loan_cuadro_ejecucion_recibido"
                               :maxlength="max_input_length"
                               :value="form_json['cuadro_ejecucion_recibido']"
                               @input="fireFormUpdated"
                               @change="fireFormUpdated">
                    </div>
                </template>

                <template v-if="expedient.contract_type === 'usury_microcredit'">
                    <div class="form-group">
                        <label class="form-label"
                               for="tipo_demanda">
                            Tipo de demanda
                        </label>
                        <select class="form-select"
                                name="tipo_demanda"
                                id="tipo_demanda"
                                :maxlength="max_input_length"
                                :value="form_json['tipo_demanda']"
                                @change="fireFormUpdated">
                            <option value="Rendición de cuentas">Rendición de cuentas</option>
                            <option value="Usura o Transparencia">Usura o Transparencia</option>
                            <option value="Posiciones deudoras">Posiciones deudoras</option>
                            <option value="Otro">Otro</option>
                        </select>
                    </div>

                    <div class="form-group">
                        <label class="form-label"
                               for="usury_microcredit_entidad_contratacion_original">
                            Entidad contratación original
                        </label>
                        <input class="form-control"
                               type="text"
                               name="entidad_contratacion_original"
                               id="usury_microcredit_entidad_contratacion_original"
                               :maxlength="max_input_length"
                               :value="form_json['entidad_contratacion_original']"
                               @input="fireFormUpdated"
                               @change="fireFormUpdated">
                    </div>

                    <div class="form-group">
                        <label class="form-label"
                               for="usury_microcredit_numeros_contrato">
                            Nºs contrato
                        </label>
                        <input class="form-control"
                               type="text"
                               name="numeros_contrato"
                               id="usury_microcredit_numeros_contrato"
                               :maxlength="max_input_length"
                               :value="form_json['numeros_contrato']"
                               @input="fireFormUpdated"
                               @change="fireFormUpdated">
                    </div>

                    <div class="form-group">
                        <label class="form-label"
                               for="usury_microcredit_numeros_prestamo">
                            Nºs préstamo
                        </label>
                        <input class="form-control"
                               type="text"
                               name="numeros_prestamo"
                               id="usury_microcredit_numeros_prestamo"
                               :maxlength="max_input_length"
                               :value="form_json['numeros_prestamo']"
                               @input="fireFormUpdated"
                               @change="fireFormUpdated">
                    </div>

                    <div class="form-group">
                        <label class="form-label"
                               for="usury_microcredit_fechas_contratacion">
                            Fechas contratación
                        </label>
                        <input class="form-control"
                               type="text"
                               name="fechas_contratacion"
                               id="usury_microcredit_fechas_contratacion"
                               :maxlength="max_input_length"
                               :value="form_json['fechas_contratacion']"
                               @input="fireFormUpdated"
                               @change="fireFormUpdated">
                    </div>

                    <div class="form-group">
                        <label class="form-label"
                               for="usury_microcredit_existe_contratos">
                            Contratos
                        </label>
                        <input class="form-check-input"
                               type="checkbox"
                               name="existe_contratos"
                               id="usury_microcredit_existe_contratos"
                               :maxlength="max_input_length"
                               :value="form_json['existe_contratos']"
                               :checked="form_json['existe_contratos'] === 'true' ? true : null"
                               @change="fireFormUpdated">
                    </div>

                    <div class="form-group">
                        <label class="form-label"
                               for="usury_microcredit_tae_contrato">
                            TAE en contrato
                        </label>
                        <input class="form-control"
                               type="text"
                               name="tae_contrato"
                               id="usury_microcredit_tae_contrato"
                               :maxlength="max_input_length"
                               :value="form_json['tae_contrato']"
                               @input="fireFormUpdated"
                               @change="fireFormUpdated">
                    </div>

                    <div class="form-group">
                        <label class="form-label"
                               for="usury_microcredit_existe_contrato_resuelto">
                            Contrato resuelto
                        </label>
                        <input class="form-check-input"
                               type="checkbox"
                               name="existe_contrato_resuelto"
                               id="usury_microcredit_existe_contrato_resuelto"
                               :maxlength="max_input_length"
                               :value="form_json['existe_contrato_resuelto']"
                               :checked="form_json['existe_contrato_resuelto'] === 'true' ? true : null"
                               @change="fireFormUpdated">
                    </div>

                    <div class="form-group">
                        <label class="form-label"
                               for="usury_microcredit_lugar_contratacion">
                            Lugar/forma de contratación
                        </label>
                        <input class="form-control"
                               type="text"
                               name="lugar_contratacion"
                               id="usury_microcredit_lugar_contratacion"
                               :maxlength="max_input_length"
                               :value="form_json['lugar_contratacion']"
                               @input="fireFormUpdated"
                               @change="fireFormUpdated">
                    </div>

                    <div class="form-group">
                        <label class="form-label"
                               for="usury_microcredit_deuda_reclamada_entidad">
                            Deuda reclamada por entidad
                        </label>
                        <input class="form-control"
                               type="text"
                               name="deuda_reclamada_entidad"
                               id="usury_microcredit_deuda_reclamada_entidad"
                               :maxlength="max_input_length"
                               :value="form_json['deuda_reclamada_entidad']"
                               @input="fireFormUpdated"
                               @change="fireFormUpdated">
                    </div>

                    <div class="form-group">
                        <label class="form-label"
                               for="usury_microcredit_cuadro_ejecucion_recibido">
                            Cuadro ejecución recibido
                        </label>
                        <input class="form-control"
                               type="datetime-local"
                               name="cuadro_ejecucion_recibido"
                               id="usury_microcredit_cuadro_ejecucion_recibido"
                               :maxlength="max_input_length"
                               :value="form_json['cuadro_ejecucion_recibido']"
                               @input="fireFormUpdated"
                               @change="fireFormUpdated">
                    </div>
                </template>

                <template v-if="expedient.contract_type === 'defaulters_list'">
                    <div class="form-group">
                        <label class="form-label"
                               for="tipo_demanda">
                            Tipo de demanda
                        </label>
                        <select class="form-select"
                                name="tipo_demanda"
                                id="tipo_demanda"
                                :maxlength="max_input_length"
                                :value="form_json['tipo_demanda']"
                                @change="fireFormUpdated">
                            <option value="Derecho al Honor">Derecho al Honor</option>
                            <option value="Otros">Otros</option>
                        </select>
                    </div>

                    <div class="form-group">
                        <label class="form-label"
                               for="defaulters_list_entidad_lista">
                            Entidad (que incluye en lista)
                        </label>
                        <input class="form-control"
                               type="text"
                               name="entidad_lista"
                               id="defaulters_list_entidad_lista"
                               :maxlength="max_input_length"
                               :value="form_json['entidad_lista']"
                               @input="fireFormUpdated"
                               @change="fireFormUpdated">
                    </div>

                    <div class="form-group">
                        <label class="form-label"
                               for="defaulters_list_fecha_entrada_listas">
                            Fecha entrada en listas
                        </label>
                        <input class="form-control"
                               type="date"
                               name="fecha_entrada_listas"
                               id="defaulters_list_fecha_entrada_listas"
                               :maxlength="max_input_length"
                               :value="form_json['fecha_entrada_listas']"
                               @input="fireFormUpdated"
                               @change="fireFormUpdated">
                    </div>

                    <div class="form-group">
                        <label class="form-label"
                               for="defaulters_list_fecha_salida_listas">
                            Fecha salida de listas
                        </label>
                        <input class="form-control"
                               type="date"
                               name="fecha_salida_listas"
                               id="defaulters_list_fecha_salida_listas"
                               :maxlength="max_input_length"
                               :value="form_json['fecha_salida_listas']"
                               @input="fireFormUpdated"
                               @change="fireFormUpdated">
                    </div>

                    <div class="form-group">
                        <label class="form-label"
                               for="defaulters_list_existe_asnef">
                            ASNEF
                        </label>
                        <input class="form-check-input"
                               type="checkbox"
                               name="existe_asnef"
                               id="defaulters_list_existe_asnef"
                               :maxlength="max_input_length"
                               :value="form_json['existe_asnef']"
                               :checked="form_json['existe_asnef'] === 'true' ? true : null"
                               @change="fireFormUpdated">
                    </div>

                    <div class="form-group">
                        <label class="form-label"
                               for="defaulters_list_existe_badexcug">
                            Badexcug
                        </label>
                        <input class="form-check-input"
                               type="checkbox"
                               name="existe_badexcug"
                               id="defaulters_list_existe_badexcug"
                               :maxlength="max_input_length"
                               :value="form_json['existe_badexcug']"
                               :checked="form_json['existe_badexcug'] === 'true' ? true : null"
                               @change="fireFormUpdated">
                    </div>

                    <div class="form-group">
                        <label class="form-label"
                               for="defaulters_list_existe_documentos_presencia_listas">
                            Tenemos documentos presencia en listas
                        </label>
                        <input class="form-check-input"
                               type="checkbox"
                               name="existe_documentos_presencia_listas"
                               id="defaulters_list_existe_documentos_presencia_listas"
                               :maxlength="max_input_length"
                               :value="form_json['existe_documentos_presencia_listas']"
                               :checked="form_json['existe_documentos_presencia_listas'] === 'true' ? true : null"
                               @change="fireFormUpdated">
                    </div>

                    <div class="form-group">
                        <label class="form-label"
                               for="defaulters_list_existe_documentos_prueba_inclusion_ilicita">
                            Tenemos documentos prueba inclusión ilícita
                        </label>
                        <input class="form-check-input"
                               type="checkbox"
                               name="existe_documentos_prueba_inclusion_ilicita"
                               id="defaulters_list_existe_documentos_prueba_inclusion_ilicita"
                               :maxlength="max_input_length"
                               :value="form_json['existe_documentos_prueba_inclusion_ilicita']"
                               :checked="form_json['existe_documentos_prueba_inclusion_ilicita'] === 'true' ? true : null"
                               @change="fireFormUpdated">
                    </div>
                </template>

                <template v-if="expedient.contract_type === 'debtor_positions'">
                    <div class="form-group">
                        <label class="form-label"
                               for="tipo_demanda">
                            Tipo de demanda
                        </label>
                        <select class="form-select"
                                name="tipo_demanda"
                                id="tipo_demanda"
                                :maxlength="max_input_length"
                                :value="form_json['tipo_demanda']"
                                @change="fireFormUpdated">
                            <option value="Posiciones deudoras">Posiciones deudoras</option>
                            <option value="Otro">Otro</option>
                        </select>
                    </div>

                    <div class="form-group">
                        <label class="form-label"
                               for="debtor_positions_numero_contrato_cc">
                            Nº contrato CC
                        </label>
                        <input class="form-control"
                               type="text"
                               name="numero_contrato_cc"
                               id="debtor_positions_numero_contrato_cc"
                               :maxlength="max_input_length"
                               :value="this.form_json['numero_contrato_cc']"
                               @input="fireFormUpdated"
                               @change="fireFormUpdated">
                    </div>

                    <div class="form-group">
                        <label class="form-label"
                               for="debtor_positions_existe_contrato">
                            Contrato
                        </label>
                        <input class="form-check-input"
                               type="checkbox"
                               name="existe_contrato"
                               id="debtor_positions_existe_contrato"
                               :maxlength="max_input_length"
                               :value="this.form_json['existe_contrato']"
                               :checked="this.form_json['existe_contrato'] === 'true' ? true : null"
                               @change="fireFormUpdated">
                    </div>

                    <div class="form-group">
                        <label class="form-label"
                               for="debtor_positions_ano_contratacion">
                            Año de contratación
                        </label>
                        <input class="form-control"
                               type="text"
                               name="ano_contratacion"
                               id="debtor_positions_ano_contratacion"
                               :maxlength="max_input_length"
                               :value="this.form_json['ano_contratacion']"
                               @input="fireFormUpdated"
                               @change="fireFormUpdated">
                    </div>

                    <div class="form-group">
                        <label class="form-label"
                               for="debtor_positions_extractos">
                            Tiene contrato
                        </label>
                        <input class="form-check-input"
                               type="checkbox"
                               name="existe_extractos"
                               id="debtor_positions_extractos"
                               :maxlength="max_input_length"
                               :value="this.form_json['existe_extractos']"
                               :checked="this.form_json['existe_extractos'] === 'true' ? true : null"
                               @change="fireFormUpdated">
                    </div>
                </template>

                <template v-if="expedient.contract_type === 'others'">
                    <div class="form-group">
                        <label class="form-label"
                               for="tipo_demanda">
                            Tipo de demanda
                        </label>
                        <input class="form-control"
                               type="text"
                               name="tipo_demanda"
                               id="tipo_demanda"
                               :maxlength="max_input_length"
                               :value="form_json['tipo_demanda']"
                               @input="fireFormUpdated"
                               @change="fireFormUpdated">
                    </div>

                    <div class="form-group">
                        <label class="form-label"
                               for="others_identificador_producto">
                            Identificador de producto
                        </label>
                        <input class="form-control"
                               type="text"
                               name="identificador_producto"
                               id="others_identificador_producto"
                               :maxlength="max_input_length"
                               :value="this.form_json['identificador_producto']"
                               @input="fireFormUpdated"
                               @change="fireFormUpdated">
                    </div>

                    <div class="form-group">
                        <label class="form-label"
                               for="others_ano_contratacion">
                            Año contratación
                        </label>
                        <input class="form-control"
                               type="text"
                               name="ano_contratacion"
                               id="others_ano_contratacion"
                               :maxlength="max_input_length"
                               :value="this.form_json['ano_contratacion']"
                               @input="fireFormUpdated"
                               @change="fireFormUpdated">
                    </div>

                    <div class="form-group">
                        <label class="form-label"
                               for="others_existe_contrato">
                            Contrato
                        </label>
                        <input class="form-check-input"
                               type="checkbox"
                               name="existe_contrato"
                               id="others_existe_contrato"
                               :maxlength="max_input_length"
                               :value="this.form_json['existe_contrato']"
                               :checked="this.form_json['existe_contrato'] === 'true' ? true : null"
                               @change="fireFormUpdated">
                    </div>

                    <div class="form-group">
                        <label class="form-label"
                               for="others_existe_factura_comprobante_pago">
                            Factura/Compr. pago
                        </label>
                        <input class="form-check-input"
                               type="checkbox"
                               name="existe_factura_comprobante_pago"
                               id="others_existe_factura_comprobante_pago"
                               :maxlength="max_input_length"
                               :value="this.form_json['existe_factura_comprobante_pago']"
                               :checked="this.form_json['existe_factura_comprobante_pago'] === 'true' ? true : null"
                               @change="fireFormUpdated">
                    </div>

                    <div class="form-group">
                        <label class="form-label"
                               for="others_existe_otros_documentos">
                            Otros documentos
                        </label>
                        <input class="form-check-input"
                               type="checkbox"
                               name="existe_otros_documentos"
                               id="others_existe_otros_documentos"
                               :maxlength="max_input_length"
                               :value="this.form_json['existe_otros_documentos']"
                               :checked="this.form_json['existe_otros_documentos'] === 'true' ? true : null"
                               @change="fireFormUpdated">
                    </div>
                </template>
            </template>

            <template v-if="can('expedient.form.fill.specific-data')">
                <div class="form-group">
                    <label class="form-label"
                           for="specific_data_tipo_procedimiento">
                        Tipo de procedimiento
                    </label>
                    <select class="form-select"
                            name="tipo_procedimiento"
                            id="specific_data_tipo_procedimiento"
                            :maxlength="max_input_length"
                            :value="form_json['tipo_procedimiento']"
                            @change="fireFormUpdated">
                        <option value="Procedimiento Ordinario">Procedimiento Ordinario</option>
                        <option value="Monitorio">Monitorio</option>
                        <option value="Juicio Verbal">Juicio Verbal</option>
                        <option value="Apelación">Apelación</option>
                        <option value="Oposición">Oposición</option>
                        <option value="Ejecución de sentencia">Ejecución de sentencia</option>
                    </select>
                </div>

                <div class="form-group">
                    <label class="form-label"
                           for="specific_data_partido_judicial">
                        Partido judicial
                    </label>
                    <input class="form-control"
                           type="text"
                           name="partido_judicial"
                           id="specific_data_partido_judicial"
                           :maxlength="max_input_length"
                           :value="form_json['partido_judicial']"
                           @input="fireFormUpdated"
                           @change="fireFormUpdated">
                </div>

                <div class="form-group">
                    <label class="form-label"
                           for="specific_data_numero_juzgado">
                        Nº de juzgado
                    </label>
                    <input class="form-control"
                           type="text"
                           name="numero_juzgado"
                           id="specific_data_numero_juzgado"
                           :maxlength="max_input_length"
                           :value="form_json['numero_juzgado']"
                           @input="fireFormUpdated"
                           @change="fireFormUpdated">
                </div>

                <div class="form-group">
                    <label class="form-label"
                           for="specific_data_numero_auto">
                        Nº de auto
                    </label>
                    <input class="form-control"
                           type="text"
                           name="numero_auto"
                           id="specific_data_numero_auto"
                           :maxlength="max_input_length"
                           :value="form_json['numero_auto']"
                           @input="fireFormUpdated"
                           @change="fireFormUpdated">
                </div>

                <div class="form-group">
                    <label class="form-label"
                           for="specific_data_lawyer">
                        Letrado
                    </label>

                    <select class="form-select"
                            name="lawyer"
                            id="specific_data_lawyer"
                            :value="!!expedient.lawyers[0] ? expedient.lawyers[0].id : null"
                            @change="updateLawyer">
                        <option value="" v-if="availableLawyers[0] === undefined">
                            No hay letrados disponibles
                        </option>

                        <option :key="lawyer.id" :value="lawyer.id" v-for="lawyer in availableLawyers" v-else>
                            {{ lawyer.surname + ", " + lawyer.name }}
                        </option>
                    </select>
                </div>

                <div class="form-group">
                    <label class="form-label"
                           for="specific_data_lawyer">
                        Procurador
                    </label>

                    <select class="form-select"
                            name="lawyer"
                            id="specific_data_attorney"
                            :value="!!expedient.attorneys[0] ? expedient.attorneys[0].id : null"
                            @change="updateAttorney">
                        <option value="" v-if="availableAttorneys[0] === undefined">
                            No hay procuradores disponibles
                        </option>

                        <option :key="attorney.id" :value="attorney.id" v-for="attorney in availableAttorneys" v-else>
                            {{ attorney.surname + ", " + attorney.name }}
                        </option>
                    </select>
                </div>

                <!-- TODO: Add the condition that 'Demanda en revisión' must exist to show these fields -->
                <div class="form-group"
                     v-if="expedient.contract_type === 'usury_card' || expedient.contract_type === 'usury_loan' || expedient.contract_type === 'usury_microcredit'">
                    <label class="form-label"
                           for="specific_data_reduccion_deuda">
                        Reducción de deuda
                    </label>
                    <input class="form-control"
                           type="text"
                           name="reduccion_deuda"
                           id="specific_data_reduccion_deuda"
                           :maxlength="max_input_length"
                           :value="form_json['reduccion_deuda']"
                           @input="fireFormUpdated"
                           @change="fireFormUpdated">
                </div>

                <div class="form-group"
                     v-if="expedient.contract_type === 'usury_card' || expedient.contract_type === 'usury_loan' || expedient.contract_type === 'usury_microcredit'">
                    <label class="form-label"
                           for="specific_data_dinero_devuelto_cliente">
                        Dinero devuelto al cliente
                    </label>
                    <input class="form-control"
                           type="text"
                           name="dinero_devuelto_cliente"
                           id="specific_data_dinero_devuelto_cliente"
                           :maxlength="max_input_length"
                           :value="form_json['dinero_devuelto_cliente']"
                           @input="fireFormUpdated"
                           @change="fireFormUpdated">
                </div>
                <!-- TODO: Add the condition that 'Demanda en revisión' must exist to show these fields -->
            </template>

            <div class="form-group">
                <label class="form-label"
                       for="observaciones">
                    Observaciones
                </label>
                <textarea class="form-control"
                          type="text"
                          name="observaciones"
                          id="observaciones"
                          :maxlength="9999"
                          :value="form_json['observaciones']"
                          @input="fireFormUpdated"
                          @change="fireFormUpdated">
                </textarea>
            </div>

            <template v-if="can('expedient.form.fill.cuantia_costas')">
                <div class="form-group">
                    <label class="form-label"
                           for="cuantia_costas">
                        Cuantía costas
                    </label>
                    <input class="form-control"
                           type="text"
                           name="cuantia_costas"
                           id="cuantia_costas"
                           :maxlength="max_input_length"
                           :value="form_json['cuantia_costas']"
                           @input="fireFormUpdated"
                           @change="fireFormUpdated">
                </div>
            </template>
        </div>
    </div>
</template>

<script>

import {withTimeout} from "../../../../helpers/requests/RequestsCore";
import {storeFormValues} from "../../../../helpers/requests/RequestsFormValues";
import {getJudicialParties} from "../../../../helpers/DataHelper";
import {can} from "../../../../helpers/Permissions";
import {setRelatedAttorney, setRelatedLawyer} from "../../../../helpers/requests/RequestsExpedients";
import {getLawyers} from "../../../../helpers/requests/RequestsLawyers";
import {getAttorneys} from "../../../../helpers/requests/RequestsAttorneys";

export default {
    name: "ExpedientDetailForm",
    props: [
        'expedient'
    ],
    components: {},
    setup() {
        return {
            can,
        }
    },
    data() {
        return {
            status: 'loading',
            max_input_length: 80,

            availableLawyers: [],
            availableAttorneys: [],

            timers: {
                store_form: '',
            },

            forms_help: {
                judicial_parties: getJudicialParties()
            },

            form_json: {},
        }
    },
    async mounted() {
        await this.loadAvailableLawyers();
        await this.loadAvailableAttorneys();
        this.setFormValues();
        this.status = 'loaded';
    },
    methods: {
        setFormValues() {
            this.form_json = this.expedient.form_values;
        },
        async updateLawyer(e) {
            let lawyer_id = e.target.value;
            await setRelatedLawyer(this.expedient.id, lawyer_id);
        },
        async updateAttorney(e) {
            let attorney_id = e.target.value;
            await setRelatedAttorney(this.expedient.id, attorney_id);
        },
        async loadAvailableLawyers() {
            this.availableLawyers = await getLawyers();
        },
        async loadAvailableAttorneys() {
            this.availableAttorneys = await getAttorneys();
        },
        fireFormUpdated(e) {
            let name = e.target.name;
            let value = e.target.value;

            if (e.target.type === 'checkbox') {
                // As string to be stored in form_values table
                value = e.target.checked + "";
            }

            if (!!value) {
                this.form_json[name] = value;
            } else {
                // We delete it to be deleted on database
                delete this.form_json[name];
            }

            this.storeFormValuesWithTimeout();
        },
        storeFormValuesWithTimeout() {
            this.$emit('storing');
            this.timers.store_form = withTimeout(async () => {
                await storeFormValues({...this.form_json}, this.expedient.id);
                this.$emit('stored');
            }, this.timers.store_form, 500);
        }
    }
}
</script>
